module.exports = __webpack_public_path__ + "img/tacog_t.taco.e780dd6.png";